import AvatarPlaceholder from "@/assets/influencer_profile/avatar-placeholder.png";
import i18n from "@/i18n";
import clsxm from "@/lib/clsxm";
import type {TCompanyGroup, TGroup} from "@/store/types";
import camelCase from "lodash/camelCase";

const OVERLAPPING_LIMIT = 4;

export const groupName = (group: TGroup | TCompanyGroup) =>
  group.smart || group.name === "favourite" ? i18n.t(camelCase(group.name)) : group.name;

export const groupImages = (
  group: TCompanyGroup,
  width: number | string = 120,
  height: number | string = 120,
  marginOffset: number = 36,
  length: number = 3,
  className: string = "",
) => {
  const slicedArray = (group.influencers ?? []).slice(0, length);
  const filledArray = Array.from({length: length - slicedArray.length}, () => null);

  return [...slicedArray, ...filledArray]?.map((influencer, index) => (
    <img
      key={`${camelCase(group.name)}-${index}`}
      src={influencer?.picture320 ? influencer.picture320 : AvatarPlaceholder}
      className={clsxm(`shrink-0 rounded-md border border-white`, className)}
      style={{
        zIndex: OVERLAPPING_LIMIT - index,
        marginLeft: !!index ? -marginOffset : 0,
        width,
        height,
      }}
    />
  ));
};
